module.exports = __webpack_public_path__ + "img/4064008900.371e893c.jpg";